import { combineReducers } from "redux";

import provinceList from "./provinceList";
import fetching from "./fetching";

export default combineReducers({ provinceList, fetching });
